// blakfy-cookie/src/i18n/translations/ru.js — Russian translations

export default {
  title: "Настройки файлов cookie",
  intro:
    "Этот сайт использует файлы cookie для улучшения вашего опыта. Подробности в Политике использования cookie.",
  policyLink: "Политика cookie",
  acceptAll: "Принять все",
  rejectAll: "Отклонить все",
  preferences: "Настройки",
  save: "Сохранить выбор",
  close: "Закрыть",
  cat: {
    essential: {
      title: "Обязательные файлы cookie",
      desc: "Необходимы для работы сайта. Не могут быть отключены.",
      always: "Всегда активны",
    },
    analytics: {
      title: "Аналитические cookie",
      desc: "Используются для сбора анонимной статистики посещений.",
    },
    marketing: {
      title: "Маркетинговые cookie",
      desc: "Используются для персонализированной рекламы и ретаргетинга.",
    },
    functional: {
      title: "Функциональные cookie",
      desc: "Используются для запоминания ваших предпочтений.",
    },
  },
  placeholder: {
    title: "Контент заблокирован",
    desc: "Чтобы просмотреть этот контент, разрешите файлы cookie категории {category}.",
    cta: "Разрешить",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
